import { MappingStructure } from './mapping-structure';

export class MappingTree extends MappingStructure {
    isOpen: boolean;
    isEditMode: boolean;
    // Used to filter tree
    isVisible: boolean;
    displayOrder: number;

    constructor()
    constructor(label: string, description: string, dispalyOrder: number)
    constructor(label?: string, description?: string, displayOrder?: number) {
        super(label, description);

        this.isOpen = false;
        this.isEditMode = false;
        this.isSelected = false;
        this.isVisible = true;
        this.displayOrder = displayOrder;
    }
}
